//quantity : 수량
//price: 기준가
//price2 : 할인가
//discount_amount : 할인수량
//standard : 기준

const calculationList = [
    {
        type: 0,
        formula: ({ price, quantity = 1 }) => price * quantity,
    },
    {
        type: 1,
        formula: ({ price, price2, quantity, discount_amount }) =>
            discount_amount > quantity ? price * quantity : price2 * quantity,
    },
    {
        type: 2,
        formula: ({ price, quantity, standard }) =>
            Math.ceil(quantity / standard) * price,
    },
    {
        //키큰장 도어 수식
        type: 3,
        formula: ({ price, quantity, standard }) =>
            Math.ceil(quantity / standard) * 2 * price,
    },
    {
        //총 깊이 연산
        type: 6,
        //  price : 가격, total_dept : 깊이 1,2,3 합산, quantity : 타겟 사이즈 합산, standard : 수량 단위
        formula: ({ price, total_dept = 0, quantity = 1, standard = 1 }) => {
            let final_price = 0;

            if (total_dept <= 600) {
                final_price = Math.ceil(quantity / standard) * 0 * price;
            } else if (total_dept > 600 && total_dept <= 800) {
                final_price = Math.ceil(quantity / standard) * 0.5 * price;
            } else if (total_dept > 800 && total_dept <= 1200) {
                final_price = Math.ceil(quantity / standard) * 1 * price;
            } else {
                final_price = Math.ceil(quantity / standard) * 1 * price;
            }

            return final_price;
        },
    },
    {
        //가구 상판 연산
        type: 7,
        formula: ({ price, quantity = 1 }) => price * quantity,
    },
    {
        //가구 깊이 연산
        type: 8,
        formula: ({ price, quantity, standard }) => {
            let final_price = 0;
            //   if (quantity <= 600) {
            //     final_price = (quantity / standard) * 0 * price;
            //   } else if (quantity > 600 && quantity <= 800) {
            //     final_price = (quantity / standard) * 0.5 * price;
            //   } else if (quantity > 800 && quantity <= 1200) {
            //     final_price = (quantity / standard) * 1 * price;
            //   } else {
            //     final_price = (1200 / standard) * 1 * price;
            //   }

            return final_price;
        },
    },
    {
        type: 9,
        formula: ({ price, quantity, standard }, target = []) => {
            let _quantity = target.reduce((acc, cur) => {
                let _cur = cur ? cur : 0;
                return acc + _cur;
            }, 0);

            return Math.ceil(_quantity / standard) * price;
        },
    },
    {
        type: 10,
        formula: ({ price, quantity }) => price * quantity,
    },
];

export default calculationList;
